export default __webpack_public_path__ + "static/media/NoProductBox.da2060e9.svg";